import styled from "styled-components"
import pesquisa from './assets/search.png';
import pin from './assets/pin.png'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Amanda_Oab from './assets/Amanda_Oab.png'
import { Hidden } from '@mui/material';

interface Props {
    imagem?: string,
}



const Titulo = styled.h2`
font-weight: 400;
    margin-bottom: 60px;
    color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 55px;
    line-height: 1em;
    max-width: 1150px;
    margin-right: auto;
    margin-left: auto;
    
    @media (max-width: 768px) {
        margin-bottom: 60px;
    color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 55px;
    //line-height: 1em;
    max-width: 350px;
    margin-right: auto;
  }


    
`

const Paragrafo = styled.p`
margin-bottom: 1.5em;
display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-family: sans-serif;
    font-size: 14px;
    color: var(--contrast);

    @media (max-width: 768px) {
    margin-bottom: 1.0em;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 2em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-family: sans-serif;
    font-size: 10px;
    color: var(--contrast);
    width: 100%;
    margin-left: 15%;
    
  }
    
`;

const ParagrafoDiv = styled.div`


    @media (max-width: 768px) {
    
    width: 390px;
    margin-left: 7%;
    
    
  }

  @media (max-width: 375px) {
    
    width: 345px;
    margin-left: 11%;
    
    
  }
    
`;

const Container = styled.div`
 display: flex;
 align-items: center; 
 margin-bottom: 10px;
 

  @media (max-width: 768px) {
    display: grid;
  }

  
`;


const boxStyles = {
    width: '600px',
    

    '@media (max-width: 768px)': {
        width: '100%',
        maxWidth: 350,
        marginLeft: 0,
    },
};

const ImagemEstilizada = styled.img`
  width: 700px;
  height: 300px;

  @media (max-width: 768px) {
    width: 67%;
    height: 270px;
    margin-left: 17%;
  
  }
  @media (max-width: 360x) {
    width: 50%;
    height: 270px;
    margin-left: 15%;
  
  }
`;
const abrirWhatsApp = () => {
    const url = "https://api.whatsapp.com/send?phone=5511983267276&text=&source=&data=";
    window.open(url, "_blank", "noopener,noreferrer");
  };

export default function Formulario() {
    return (

        <>
            <Titulo>
                5 anos de existência com o
                <strong> olhar sempre voltado para o futuro</strong>
            </Titulo>

            <Container>
                <figure style={{ margin: 0, marginRight: '20px' }}>
                    <ImagemEstilizada
                        loading="lazy"
                        decoding="async"
                        src={Amanda_Oab}
                        alt="Descrição da imagem"
                        title="Design sem nome (48) (1)"
                        sizes="(max-width: 2270px) 100vw, 2270px"
                    />
                </figure>

                <div style={boxStyles}>
                    <ParagrafoDiv>
                    <Paragrafo>
                        <Typography variant="body1" gutterBottom>
                            Bem-vindo à Amanda Alves Advocacia. Com mais de 5 anos de trajetória, cultivamos uma tradição jurídica sólida,  Unimos o rigor da tradição com uma busca constante pela inovação, proporcionando soluções jurídicas eficazes e preventivas.
                        </Typography>
                    </Paragrafo>
                    </ParagrafoDiv>

                    <ParagrafoDiv>
                    <Paragrafo>
                        <Typography variant="body1" gutterBottom>
                            Marcada pela experiência e alta capacitação técnica, tem como missão transformar pessoas através do conhecimento jurídico descomplicado. Nosso propósito é direcionar nossos clientes em suas decisões, elaborando soluções personalizadas e eficazes. Para nós, o Direito é um instrumento de crescimento e sucesso.
                        </Typography>
                    </Paragrafo>
                    </ParagrafoDiv>

                    <ParagrafoDiv>
                    <Paragrafo>
                        <Typography variant="body1" gutterBottom>
                            Convidamos você a descobrir o que significa ter ao seu lado um escritório com uma vasta experiência, mas que nunca perdeu de vista a importância de se adaptar e inovar conforme as necessidades futuras de seus clientes. Descubra como a Amanda Alves Advocacia pode ajudá-lo a superar obstáculos e atingir seus objetivos por meio do conhecimento jurídico descomplicado.
                        </Typography>
                    </Paragrafo>
                    </ParagrafoDiv>

                    <Button variant="contained" color="success" sx={{ borderRadius: 45, color: "#7bdcb5", marginLeft:"27%" }} onClick={abrirWhatsApp}>
                        Quero Entrar em Contato
                    </Button>
                </div>
            </Container>
        </>
    );
}